import '@babel/polyfill'
import Vue from 'vue'
import axios from './plugins/axios'
import App from './App.vue'
import router from './router'
// import axios from 'axios'
import 'normalize.css/normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import VueLazyLoad from 'vue-lazyload'
import MetaInfo from 'vue-meta-info'

Vue.config.productionTip = false
Vue.prototype.$ajax = axios
Vue.use(VueLazyLoad)
Vue.use(MetaInfo)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
